"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Stamp = /** @class */ (function () {
    function Stamp(props) {
        this.type = props.type;
        this.imageUrl = props.imageUrl;
        this.text = props.text;
        this.options = props.options;
    }
    Stamp.textboxStamp = function (text) {
        return new Stamp({ type: 'textbox', text: text });
    };
    Stamp.setPhraseStamp = function (text, options) {
        return new Stamp({ type: 'setPhrase', text: text, options: options });
    };
    Stamp.svgStamp = function (svgUrl) {
        return new Stamp({ type: 'svg', imageUrl: svgUrl });
    };
    Stamp.dateStamp = function (options) {
        return new Stamp({ type: 'date', options: options });
    };
    return Stamp;
}());
exports.Stamp = Stamp;
//# sourceMappingURL=Stamp.js.map